<template>
  <div class="main">
    <div class="main-desc">
      <div>
        <el-image :src="require('../assets/image/chengdesc.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div>
        <el-image :src="require('../assets/image/chengdesc2.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <span class="beian">网站备案号：渝ICP备2024032881号-1</span>
      </div>
    </div>
    <div class="main-con" style="align-items: flex-end">
      <ul class="legen">
        <li class="legen-li">
          <div class="dian"></div>
          <span>保靖县普戎镇马福村</span>
        </li>
        <li class="legen-li">
          <div class="dian" style="background-color: #ab61ff"></div>
          <span>保靖县清水乡门前村</span>
        </li>
        <li class="legen-li">
          <div class="dian" style="background-color: #f6a31e"></div>
          <span>龙山县苗儿滩镇捞车村</span>
        </li>
        <li class="legen-li">
          <div class="dian" style="background-color: #00b1e2"></div>
          <span>龙山县苗儿滩镇叶家寨</span>
        </li>
        <li class="legen-li">
          <div class="dian" style="background-color: #fa5649"></div>
          <span>永顺县对山乡</span>
        </li>
      </ul>
      <div class="main-con-box">
        <div style="position: relative; height: 100%">
          <el-image :src="require('../assets/image/chengdefut.jpg')" fit="contain " :class="['main-img', activeArea == '' ? '' : 'hide']" style="min-width: 808px">
            <div slot="placeholder" class="custom-loading">
              <!-- 这里是你的自定义加载动画 -->
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
          <video ref="videob" muted :class="['video', activeArea == 'b' ? 'show' : '']">
            <source :src="require('../assets/video/cheng/videoblue.mp4')" type="video/mp4" />
          </video>
          <video ref="videog" muted :class="['video', activeArea == 'g' ? 'show' : '']">
            <source :src="require('../assets/video/cheng/videogreed.mp4')" type="video/mp4" />
          </video>
          <video ref="videop" muted :class="['video', activeArea == 'p' ? 'show' : '']">
            <source :src="require('../assets/video/cheng/videopurple.mp4')" type="video/mp4" />
          </video>
          <video ref="videor" muted :class="['video', activeArea == 'r' ? 'show' : '']">
            <source :src="require('../assets/video/cheng/videored.mp4')" type="video/mp4" />
          </video>
          <video ref="videoy" muted :class="['video', activeArea == 'y' ? 'show' : '']">
            <source :src="require('../assets/video/cheng/videoyellow.mp4')" type="video/mp4" />
          </video>
        </div>
        <div class="btn-box">
          <el-button class="btn" :type="activeArea == 'g' ? 'primary' : ''" round size="small" @click="handleAreaClick('g')">保靖县普戎镇马福村</el-button>
          <el-button class="btn" :type="activeArea == 'p' ? 'primary' : ''" round size="small" @click="handleAreaClick('p')">保靖县清水乡门前村</el-button>
          <el-button class="btn" :type="activeArea == 'y' ? 'primary' : ''" round size="small" @click="handleAreaClick('y')">龙山县苗儿滩镇捞车村</el-button>
          <el-button class="btn" :type="activeArea == 'b' ? 'primary' : ''" round size="small" @click="handleAreaClick('b')">龙山县苗儿滩镇叶家寨</el-button>
          <el-button class="btn" :type="activeArea == 'r' ? 'primary' : ''" round size="small" @click="handleAreaClick('r')">永顺县对山乡</el-button>
        </div>
      </div>
      <div class="legenr">
        <el-image :src="require('../assets/image/chengcon2.jpg')" style="width: 175px; height: 160px; margin-left: 10px">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from '../utils/eventBus.js'
export default {
  name: 'Cheng',
  data() {
    return {
      activeArea: ''
    }
  },
  methods: {
    handleAreaClick(area) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.activeArea = area
      this.$refs['video' + area].play()
    }
  }
}
</script>
<style lang="scss" scoped>
.main-con-box,
.legenr {
  padding-bottom: 80px;
}
.legen {
  padding-bottom: 96px;
  width: 175px;
  flex-shrink: 0;
  .legen-li {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-top: 5px;
    .dian {
      margin-right: 10px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #00c76c;
    }
  }
}
.btn-box {
  position: absolute;
  white-space: nowrap;
  bottom: 10px;
  width: 100%;
  .btn {
    min-width: calc(20% - 10px);
    margin-bottom: 6px;
  }
}

@media screen and (max-height: 860px) {
  .main-desc {
    width: 280px;
  }

  .btn-box {
    white-space: wrap;
  }
}
</style>
